import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getSex } from 'src/shared/services/formSettingService';

// Kön: kontrollerad, sökbar och avvalbar Autocomplete (samma UX som Land/Betalmetod).
// Värdet behålls som hela optionsobjektet {name, value} — memberDataGrid läser .value och chippen .name.
type SexOption = { name: string; value: string };

export const MemberAdvancedSearchGender = () => {
  const { control } = useFormContext();
  const { t } = useTranslation(['common']);
  const isMounted = useIsMounted();
  const [options, setOptions] = useState<SexOption[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const result = await getSex();
        if (isMounted()) {
          setOptions((result.data.results[0]?.extraOptions ?? []).filter((x) => x.name !== ''));
        }
      } catch (e) {
        if (isMounted()) ConsoleHelper.log(e);
      }
    })();
  }, [isMounted]);

  return (
    <Controller
      name='sex'
      control={control}
      render={({ field }) => (
        <Autocomplete
          options={options}
          size='small'
          fullWidth
          getOptionLabel={(o) => o.name}
          isOptionEqualToValue={(o, v) => o.value === v.value}
          value={field.value || null}
          onChange={(_, newValue) => field.onChange(newValue || '')}
          renderInput={(params) => (
            <TextField {...params} label={t('common:form.gender')} placeholder={t('common:form.all')} InputLabelProps={{ shrink: true }} />
          )}
        />
      )}
    />
  );
};
